<template>
    <text-input
      :label="label"
      :prop="prop"
      :required="required"
      type="number"
      :decimals="decimals"
      v-model="form"
      :pattern="pattern"
      :size="size"
      align-input="right"
      :min="min"
      :max="max"
      :prefix="isSuffixSymobl ? null : currency"
      :suffix="isSuffixSymobl ? currency : null"
      @input="v = parseFloat($event)"
     :disabled="disabled"
     :placeholder="placeholder"
     :no-form="noForm"
     @change="updated">
   </text-input>
</template>

<script>

import NumberMixins from '@/mixins/NumberMixins'
import {settings} from '@/components/Data'

export default {
  name: 'currency-input',

  mixins: [NumberMixins],

  props: {

    label: {
      type: String,
      default: 'Amount'
    },

    value: {
//      type: Number,
      required: true
    },

    prop: {
      type: String,
      default: null
    },

    decimals: {
      type: Number,
      default: 2
    },

    pattern: {
      type: Number,
      default: null
    },

    min: {
      type: Number,
      default: 0
    },

    max: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER
    },

    size: {
      type: String,
      default: 'default'
    },


    isSuffixSymobl: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String,
      default: null
    },

    helpText: {
      type: String,
      default: null
    },

    noForm: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    // Display-only formatting for the raw <input type="number">. Must NEVER
    // introduce thousands separators (browser rejects a grouped string and
    // blanks the field) and must NEVER coerce empty/null/NaN to "0.00" —
    // that would regress optional money fields like tax to a fake zero.
    displayValue (v) {
      if (v === null || v === undefined || v === '') {
        return v
      }

      let n = Number(v)
      if (isNaN(n)) {
        return v
      }

      return n.toFixed(this.decimals)
    },

    updated (value) {
      let rounded = this.roundTo(value, this.decimals)
      this.$emit('input', rounded)
      this.$emit('change', rounded)
      this.form = this.displayValue(rounded)
    }
  },

  watch: {
    value: function (val) {
      this.form = this.displayValue(val)
    }
  },


  data () {
    return {
      form: this.displayValue(this.value),
      currency: settings.currency
    }
  }

}
</script>

<style scoped>
input {
  float: right;
  clear: both;
}
</style>
